import DayJS from './DayJS'
import { setUserPresent } from '../infrastructure/api-present'
import { UserCoursesDTO } from '../interfaces/api-activation'

export const setPresentStatus = (course: UserCoursesDTO) => {
    const { nextClass, status, start, courseId } = course
    // `enrolled` puede venir de la caché de cursos (staleTime de 5 h) aunque el perfil ya haya empezado:
    // se decide con la hora real y el inicio del perfil, no con el status guardado
    if (status !== 'studying' && status !== 'enrolled') return console.info(`User is not studying, don't require to set present.`)
    if (status === 'enrolled' && !start) return console.info(`Profile start date is not available, don't require to set present.`)
    if (!nextClass?.open || !nextClass?.end) return console.warn('Course next class info is not available.')

    // El presente sale desde que abre la ventana o desde que empieza el perfil, lo que pase después.
    // Si el perfil empieza después de esta clase (otra fecha de inicio), no se manda: api-present no lo valida
    const open = DayJS(nextClass.open)
    const from = start && DayJS(start).isAfter(open) ? DayJS(start) : open
    const end = DayJS(nextClass.end)
    if (!from.isBefore(end)) return console.info(`Profile starts after this class, don't require to set present.`)

    const now = DayJS()
    if (now.isBefore(from)) return setPresentTimer(courseId, from)
    if (now.isBefore(end)) {
        setUserPresent(courseId)
        console.info('User is in class range, setting present.')
    }
}

// Máximo de setTimeout: con más de ~24,8 días desborda y dispara al instante
const MAX_TIMEOUT_MS = 2_147_483_647

const setPresentTimer = (courseId: string, at: DayJS.Dayjs) => {
    const fromNow = at.diff(DayJS(), 'milliseconds')
    // nextClass puede estar a meses (egg-api-signup la ancla al inicio de la cohorte): no se agenda
    if (fromNow > MAX_TIMEOUT_MS) return console.info(`Next class is too far to set a present timer.`)
    console.info(`A timer was set for the user to set present at ${at.locale('en').format()}, ${at.locale('en').fromNow()}`)
    return setTimeout(() => setUserPresent(courseId), fromNow)
}
